export const APP_NAME: string = "EtsyGen v1.37";